import { ColDef, ValueFormatterParams } from 'ag-grid-enterprise';
import { alignLeft, alignRight, comparator, mergeClasses } from './utils';
import { formatPrettyNumber } from '@/modules/common/components/pretty-number';
import * as cols from './common';
import { FrontendOrder } from '@/connect/gen/modules/apiengine/services/oms/oms_pb';
import * as marketplaceCols from './marketplace';
import { OmsOrderStatus } from '@/connect';
import { enumValueFormatter } from '@/modules/common/components/ag-table/columns/value-formatters';
export { side, ticker, cusip } from './marketplace';

export type OrdersWithEqualFieldsMap = Map<
  FrontendOrder,
  { status: boolean; agreements: boolean; minQuantity: boolean; fee: boolean }
>;

interface Config {
  ordersWithEqualFields: OrdersWithEqualFieldsMap;
}

export function status(config: Config): ColDef<FrontendOrder> {
  return {
    field: 'orderStatus',
    colId: 'orderStatus',
    headerName: 'Status',
    ...alignLeft(),
    ...enumValueFormatter(OmsOrderStatus),
    ...mergeClasses([
      {
        cellClass: (params) =>
          config.ordersWithEqualFields.get(params.data!)?.status ? 'error--text' : undefined,
      },
    ]),
  };
}

export function agreements(config: Config): ColDef<FrontendOrder> {
  const baseColDef = marketplaceCols.agreements();
  return {
    ...baseColDef,
    ...mergeClasses([
      baseColDef,
      {
        cellClass: (params) =>
          config.ordersWithEqualFields.get(params.data!)?.agreements ? 'error--text' : undefined,
      },
    ]),
  };
}

export function executed(): ColDef<FrontendOrder> {
  return {
    field: 'totalExecQty',
    colId: 'totalExecQty',
    headerName: 'Executed',
    valueFormatter: (params: ValueFormatterParams<FrontendOrder, bigint>) =>
      !params.value ? '–' : formatPrettyNumber(params.value),
    comparator: comparator.bigint,
    ...alignRight(),
  };
}

export function quantity(): ColDef<FrontendOrder> {
  return cols.quantity({
    field: 'quantity',
    headerName: 'Quantity',
  });
}

export function minQuantity(config: Config): ColDef<FrontendOrder> {
  const baseColDef = marketplaceCols.minQuantity();
  return {
    ...baseColDef,
    ...mergeClasses([
      baseColDef,
      {
        cellClass: (params) =>
          config.ordersWithEqualFields.get(params.data!)?.minQuantity ? 'error--text' : undefined,
      },
    ]),
  };
}

export function fee(config: Config): ColDef<FrontendOrder> {
  const baseColDef = marketplaceCols.fee();
  return {
    ...baseColDef,
    ...mergeClasses([
      baseColDef,
      {
        cellClass: (params) =>
          config.ordersWithEqualFields.get(params.data!)?.fee ? 'error--text' : undefined,
      },
    ]),
  };
}

export function rebate(config: Config): ColDef<FrontendOrder> {
  const baseColDef = marketplaceCols.rebate();
  return {
    ...baseColDef,
    ...mergeClasses([
      baseColDef,
      {
        cellClass: (params) =>
          config.ordersWithEqualFields.get(params.data!)?.fee ? 'error--text' : undefined,
      },
    ]),
  };
}
